import { privateApi } from "@core/libs/axios/apiInstances"
import { handleResponse } from "@core/libs/axios/serviceHandler"
import { ProjectSchema } from "@modules/project/workspace/types/TProject"
import type { TProject } from "@modules/project/workspace/types"

function mapProject(dto: unknown): TProject {
  const parsed = ProjectSchema.safeParse(dto);
  if (!parsed.success) {
    console.warn(
      "[mapProject] Zod parse failed:",
      parsed.error.issues,
    );
    throw {
      success: false,
      message: "Response validation failed",
      error: {
        code: "PARSE_ERROR",
        message: "Project response did not match expected shape",
        details: parsed.error.issues,
      },
      data: null,
    };
  }
  return parsed.data;
}

export async function getProject(
  workspaceId: string,
  projectId: string,
  signal?: AbortSignal,
): Promise<TProject> {
  const data = await handleResponse<TProject>(
    privateApi.get(`/projects/${workspaceId}/${projectId}/`, { signal }),
  )
  return mapProject(data)
}
